/**
 * The update history admins open from the version number (#90), newest first.
 *
 * Add an entry (or a line to today's) with every feature or fix merged into `development`. Entries
 * are dated rather than tied to a version, because dev and prod tags are numbered separately.
 * Keep each line short and written for the people using the dashboard, not for developers.
 */
export interface ChangelogEntry {
  /** yyyy-mm-dd, the day it was merged. */
  date: string;
  en: string[];
  ar: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    date: '2026-11-03',
    en: [
      'Version number in the menu; admins can open this update history.',
      'Partner leads: follow up on organizations that asked to join and create them as clients.',
      'Referrers list: who signed up for a referral link, with leads sent and signed.',
      'The first menu item is no longer hidden behind the version number.',
    ],
    ar: [
      'رقم الإصدار في القائمة، ويمكن للمشرف فتح سجل التحديثات هذا.',
      'طلبات الشراكة: متابعة الجهات التي طلبت الانضمام وإنشاؤها كعملاء.',
      'قائمة المُحيلين: من سجّل للحصول على رابط إحالة، مع عدد الطلبات المرسلة والموقّعة.',
      'لم يعد أول عنصر في القائمة مخفيًا خلف رقم الإصدار.',
    ],
  },
  {
    date: '2026-11-01',
    en: [
      'Canceled claims now say why they were canceled.',
      'Claim screens: shorter step labels, new tabs, staff can cancel, clearer pickup message and times.',
      'Payment screen and claim popup fixes.',
      'No more "No pickup found" error popup on shipping claims.',
    ],
    ar: [
      'الطلبات الملغاة توضّح الآن سبب الإلغاء.',
      'شاشات الطلب: خطوات أقصر، تبويبات جديدة، إمكانية الإلغاء للموظفين، ورسالة وأوقات استلام أوضح.',
      'إصلاحات في شاشة الدفع ونافذة الطلب.',
      'إخفاء رسالة الخطأ "لا يوجد استلام" في طلبات الشحن.',
    ],
  },
  {
    date: '2026-10-29',
    en: [
      'Clearer claims list and stored items list.',
      'Stored item details page: clearer layout and texts.',
      'Status timeline explains what "Preparing" waits for, and names "Delivered" by how the item was received.',
    ],
    ar: [
      'قائمة طلبات وقائمة مفقودات مخزّنة أوضح.',
      'صفحة تفاصيل المفقود المخزّن: تصميم ونصوص أوضح.',
      'المسار الزمني للحالة يوضّح ما تنتظره حالة "قيد التجهيز"، ويسمّي "تم التسليم" حسب طريقة الاستلام.',
    ],
  },
  {
    date: '2026-10-28',
    en: [
      'Claim details (customer and admin): clearer layout, status timeline and waybill tracking.',
      'Custody items: a bag with its contents, and bringing back items handed to police.',
      'Embeddable claim widget and claim tracking for clients\' websites.',
      'Pickup details after handover: what to bring, map link and hours.',
      '"Needs measuring" badge on the found items list.',
    ],
    ar: [
      'تفاصيل الطلب (للعميل والمشرف): تصميم أوضح، مسار زمني للحالة وتتبّع بوليصة الشحن.',
      'الأمانات: حقيبة بمحتوياتها، واسترجاع ما سُلّم للشرطة.',
      'نموذج طلب وتتبّع يمكن تضمينه في مواقع العملاء.',
      'تفاصيل الاستلام بعد التسليم: ما يجب إحضاره، رابط الخريطة وأوقات العمل.',
      'شارة "يحتاج قياس" في قائمة المفقودات.',
    ],
  },
  {
    date: '2026-10-26',
    en: [
      'Guest claims: file a claim with an email code, get a claim code, and track it without an account.',
      'Claim code shown on the customer\'s claim view.',
      'Payment keeps the customs declared value.',
    ],
    ar: [
      'طلبات الزوار: تقديم طلب برمز يصل للبريد، والحصول على رمز الطلب وتتبّعه دون حساب.',
      'عرض رمز الطلب في صفحة طلب العميل.',
      'الدفع يحتفظ بالقيمة المصرّح بها للجمارك.',
    ],
  },
  {
    date: '2026-10-25',
    en: [
      'Browser tab shows the current page name.',
      'Date range picker fixes: no more blank dashboard or dates one day early.',
    ],
    ar: [
      'تبويب المتصفح يعرض اسم الصفحة الحالية.',
      'إصلاحات منتقي الفترة: لا لوحة فارغة ولا تواريخ متقدمة بيوم.',
    ],
  },
];
